import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DialogModal } from ".";
import { hideDialog, showDialog } from "../../appRedux/actions/common";
import { deleteOffer, getOffersList } from "../../appRedux/actions/offers";

const BodyView = ({ info }) => {
  const dispatch = useDispatch();
  const queryInfo = useSelector((state) => state.offers.queryInfo);

  return (
    <Fragment>
      <div className="form-header">
        <h3>Remove Offer</h3>
        <p>Are you sure you want to remove this offer?</p>
      </div>
      <div className="modal-btn delete-action">
        <div className="row">
          <div className="col-6">
            <button
              onClick={() => dispatch(hideDialog())}
              className="btn btn-primary continue-btn"
              style={{ width: "100%" }}
            >
              Cancel
            </button>
          </div>
          <div className="col-6">
            <button
              onClick={() => {
                dispatch(deleteOffer({ id: info._id }))
                  .then(() => {
                    dispatch(getOffersList(queryInfo)).catch(() => {});
                    dispatch(hideDialog());
                  })
                  .catch(() => {});
              }}
              className="btn btn-primary cancel-btn"
              style={{ width: "100%" }}
            >
              Remove
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

function DeleteModalComponent({ info }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const dialog = useSelector((state) => state.common.dialog);

  useEffect(() => {
    if (!dialog) setOpen(dialog);
  }, [dialog]);

  return (
    <Fragment>
      <button
        className="btn btn-sm btn-outline-danger"
        style={{ padding: "4px 8px" }}
        onClick={() => {
          setOpen(true);
          dispatch(showDialog({ title: "", hideHeader: true }));
        }}
        title="Remove"
        key="delete_offer"
      >
        <i className="fa fa-trash" />
      </button>
      {open && (
        <DialogModal bodyView={<BodyView info={info} />} />
      )}
    </Fragment>
  );
}

export default DeleteModalComponent;
